import { OrdersActionsTypes } from '../../../enums/ActionEnums';
export const orderOverviewReducerReducerState = {
    announcedReturn: null,
    returnedSales: null,
    orderedItems: null,
    returnItems: null,
    returnReasons: [],
};
export const ordersReducer = (state = orderOverviewReducerReducerState, action) => {
    switch (action.type) {
        case OrdersActionsTypes.SET_ORDERED_ITEMS:
            return Object.assign(Object.assign({}, state), { orderedItems: action.payload });
        case OrdersActionsTypes.SET_RETURN_ITEMS:
            return Object.assign(Object.assign({}, state), { returnItems: action.payload });
        case OrdersActionsTypes.SET_ANNOUNCED_RETURN:
            return Object.assign(Object.assign({}, state), { announcedReturn: action.payload });
        case OrdersActionsTypes.SET_RETURN_REASONS:
            return Object.assign(Object.assign({}, state), { returnReasons: action.payload });
        case OrdersActionsTypes.SET_RETURNED_SALES:
            return Object.assign(Object.assign({}, state), { returnedSales: action.payload });
        case OrdersActionsTypes.SET_SUBMIT_RETURN_ITEMS_STATE:
            return Object.assign(Object.assign({}, state), { submitReturnItemsState: action.payload });
        case OrdersActionsTypes.SET_UPDATE_ANNOUNCED_RETURN_STATE:
            return Object.assign(Object.assign({}, state), { updateAnnouncedReturnState: action.payload });
        case OrdersActionsTypes.SET_ORDERED_ITEMS_STATE:
            return Object.assign(Object.assign({}, state), { orderedItemsState: action.payload });
        default:
            return state;
    }
};
